export enum EArticleResourceType {
    Github = "github",
    Demo = "demo",
    Discord = "discord",
    Other = "other",
}